<script>
import {BCol, BFormGroup, BFormTextarea, BRow} from 'bootstrap-vue'
import ExpressionInterpreter from "@core/components/common/expression-language/ExpressionInterpreter.vue";

export default {
    components: {
        BCol, BFormGroup, BFormTextarea, BRow, ExpressionInterpreter
    },
    props: {
        rule: {
            required: true,
            type: Object
        },
        showDescription: {
            type: Boolean,
            default: false
        },
        explanation: {
            type: Object,
            default: null
        }
    },
    data() {
        return {
            description: this.rule.description || '',
            expression: this.rule.expression
        };
    },
    methods: {
        emit() {
            this.$emit('change', {
                description: this.description,
                expression: this.expression,
                rule: this.rule
            });
        }
    },
    watch: {
        rule() {
            this.description = this.rule.description || '';
            this.expression = this.rule.expression;
        }
    }
}
</script>

<template>
    <div>
        <b-row>
            <b-col>
                <b-form-group
                    v-if="showDescription"
                    :label="$t('Component(Label):description')"
                >
                    <b-form-textarea
                        v-model="description"
                        @input="emit"
                        :placeholder="$t('Component(Placeholder):type-here')"
                    />
                </b-form-group>
                <b-form-group
                    :label="$t('Component(Label):expression')"
                >
                    <b-form-textarea
                        v-model="expression"
                        @input="emit"
                        :placeholder="$t('Component(Placeholder):type-here')"
                    />
                </b-form-group>
                <ExpressionInterpreter
                    :expression="expression"
                    :explanation="explanation"
                />
            </b-col>
            <b-col cols="auto" class="pt-4">
                <button
                    type="button"
                    class="btn btn-danger btn-sm"
                    @click="$emit('remove', rule)"
                >
                    <feather-icon icon="TrashIcon" />
                </button>
            </b-col>
        </b-row>
    </div>
</template>
